<template>
  <div>
    <va-modal
      :value="isOpen"
      id="checkupPatientAppointmentMeasurements"
      ref="createOrUpdatePatientModal"
      size="large"
      :showOkay="false"
      :cancelText="$t('modal.close')"
      @cancel="onClickCancel"
    >

      <div class="person-details evollu-form">

        <div class="row">
          <h4>
            {{ $t(`people_manager.patient.checkup_appointment_details_title`)}}
          </h4>
        </div>
        <div>
          <p>{{$t('people_manager.table.name')}}: <span class="is-bold">{{patientName}}</span></p>
          <p>{{$t('evocall.active_users.started_at')}}: <span class="is-bold">{{appointmentFrom}}</span></p>
          <p>{{$t('evocall.active_users.ended_at')}}: <span class="is-bold">{{appointmentTo ? appointmentTo : $t('clinical.appointments.ongoing')}}</span></p>
        </div>
        <va-separator style="height: 6px; border-radius: 25px"/>
        <div class="grid-container" v-if="measurements.length > 0">
          <va-card :style="{ width: elem.measurementGroup.idMeasurementGroup === 9000 ? '100%' : '49%' }" v-for="elem in measurements">

            <div class="mb-0 row d-flex align-items-center">
              <i :class="handleIconStr(elem)" style="height: 40px"></i>
              &ensp;
              <h4>
                {{$t(`checkup_plus.person.rules.rule_creation.measurement_group.${elem.measurementGroup.idMeasurementGroup}`)}}
              </h4>
            </div>

            <div class="row ml-3">
              <span class="is-bold" style="color:#b3b3b3; font-size: 14px"> {{elem.createdAt | localTime('YYYY-MM-DD HH:mm')}}</span>
            </div>
            <div class="col-12 d-flex flex-column"  v-if="elem.measurementGroup.idMeasurementGroup === 9000">
              <HearingTest
                class="mt-4"
                :hideTitle="true"
                :show-average="true"
                :ht="parseTonalTestData(elem)"/>
            </div>
            <div class="col-12 d-flex flex-column"  v-else-if="elem.measurementGroup.idMeasurementGroup === 1014">
              <span v-for="measurement in elem.measurements" v-if="!ignoredMeasurementTypes.includes(handleTypeName(measurement.typeName))" >
                {{$t(`dashboard_new_evollu.measurement_types.questions.${measurement.typeId}`)}}:
                <span class="is-bold">{{ $t(`checkup_plus.questionnaires.answers_by_type_id.${measurement.typeId}.${measurement.stringValue}`)}}</span>
              </span>
            </div>
            <div class="col-12 d-flex flex-column"  v-else>
              <span v-for="measurement in elem.measurements" v-if="!ignoredMeasurementTypes.includes(handleTypeName(measurement.typeName))" >
                {{$t(`dashboard_new_evollu.measurement_types.${handleTypeName(measurement.typeName)}`)}}:
                <span v-if="measurement.showTrueFalseIcon">
                  <i class="fa fa-check" v-if="measurement.value === 1"></i>
                  <i class="fa fa-times" v-else></i>
                </span>
                <span class="is-bold" v-else-if="measurement.showYesNoLabel">
                  {{$t(`rules.labels.${measurement.stringValue}`)}}
                </span>
                <span class="is-bold" v-else-if="measurement.shouldTranslate">
                  {{$t(`${measurement.prefixTranslation}${measurement.stringValue.toLowerCase()}`)}}
                </span>
                <span class="is-bold" v-else>{{measurement.stringValue}} <span v-if="measurement.units"> {{ measurement.units}}</span></span>
              </span>
            </div>

            <div class="row mt-4 ml-3" style="margin-bottom: 0 !important;">
              <h5>{{ $t('audiology_4_all.titles.columnTitles.result') }}</h5>
            </div>
            <div class="row mt-1 ml-3" v-if="elem.chartResults.length === 0">
              <span>N/A</span>
            </div>
            <div class="row mt-1 ml-3" v-else v-for="result in elem.chartResults">
              <span>
                {{result.code ? $t(`dashboard_new_evollu.parameters.graphs.legends.${result.code.toLowerCase()}`) : "N/A"}}
              </span>
            </div>
          </va-card>
        </div>
        <div v-else class="d-flex justify-content-center">
          <h4 class="is-bold text-black-50">{{$t('people_manager.patient.appointment.no_measurements')}}</h4>
        </div>

      </div>

    </va-modal>
  </div>

</template>

<script>
import { fromJS } from 'immutable';
import moment from 'moment/moment';
import HearingTest from '@/components/common/HearingTest.vue';

export default {
  components: { HearingTest },
  props: {
    measurements: {
      type: Array,
      required: true
    },
    patientName: {
      type: String,
      required: true
    },
    appointmentFrom: {
      type: String,
      required: true
    },
    appointmentTo: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      isOpen: false,
      ignoredMeasurementTypes: ['optometry_survey_q1_short',
        'optometry_survey_q2_short',
        'optometry_survey_q3_short',
      'optometry_survey_q4_short',
      'optometry_survey_q5_short',
      'optometry_survey_q6_short',
      'optometry_survey_q7_short',
        'optometry_survey_q8_short']
    }
  },
  mounted: function () {
    this.isOpen = true
    this.measurements.forEach(elem => {
      if(elem.measurementGroup.idMeasurementGroup === 9050) {
        elem.measurements.forEach(meas => {
          switch (meas.typeId){
            case 9069:
              meas.showTrueFalseIcon = true
              break;
            case 9050:
              meas.showTrueFalseIcon = true
              break;
            case 9051:
              meas.showTrueFalseIcon = true
              break;
            case 9052:
              meas.showTrueFalseIcon = true
              break;
            case 9057:
              meas.showTrueFalseIcon = true
              break;
            case 9058:
              meas.showTrueFalseIcon = true
              break;
          }
        })
      }
      else if(elem.measurementGroup.idMeasurementGroup === 4) {
        elem.measurements.forEach(meas => {
          switch (meas.typeId){
            case 58:
              meas.showYesNoLabel = true
              break;
          }
        })
      }
      else if(elem.measurementGroup.idMeasurementGroup === 6000) {
        elem.measurements.forEach(meas => {
          switch (meas.typeId){
            case 6000:
              meas.shouldTranslate = true
              meas.prefixTranslation = 'dashboard_new_evollu.donut_chart_labels.frailty.'
              break;
          }
        })
      }
    })

  },
  methods: {
    fromJS,
    onClickCancel: function () {
      this.$emit('cancel')
      setTimeout(() => {
        this.isOpen = false
      }, 500)
    },
    handleIconStr: function(elem) {
      const iconName = this.measurementTypesInfo.find(info => info.measurementGroupId === elem.measurementGroup.idMeasurementGroup).iconName
      return `i-checkup-${iconName}`
    },
    handleTypeName: function(typeName) {
      if(typeName.includes('_value')) {
        typeName = typeName.replace('_value', '')
      }
      typeName = typeName.replace('-', '_')
      return typeName.replace(/ /g, "_").toLowerCase() + '_short'
    },
    parseTonalTestData: function (data) {
      //console.log(data)
      const HEAR_LOSS_LEFT_TYPE_ID = 9009
      const HEAR_LOSS_RIGHT_TYPE_ID = 9010
      const HEAR_LOSS_RESULT_TYPE_ID = 9011

      this.audiologyData = []
      const frequenciesToTypeIdMapping = {
        9001: {side: 'left', freq: 1000},
        9002: {side: 'left', freq: 2000},
        9003: {side: 'left', freq: 4000},
        9004: {side: 'left', freq: 6000},
        9005: {side: 'right', freq: 1000},
        9006: {side: 'right', freq: 2000},
        9007: {side: 'right', freq: 4000},
        9008: {side: 'right', freq: 6000}
      }
      let results = {
        left: {},
        right: {}
      }
      data.measurements.forEach(meas => {
        if (frequenciesToTypeIdMapping[meas.typeId]) {
          const side = frequenciesToTypeIdMapping[meas.typeId].side
          const freq = frequenciesToTypeIdMapping[meas.typeId].freq
          if (side && freq) {
            results[side][freq] = meas.value
          }
        }
      })
      let resultStr = `F\t1000\t2000\t4000\t6000\nR\t${results.right['1000']}\t${results.right['2000']}\t${results.right['4000']}\t${results.right['6000']}\nL\t${results.left['1000']}\t${results.left['2000']}\t${results.left['4000']}\t${results.left['6000']}`
      return {
        created_at: moment(data.date).format('YYYY-MM-DD HH:mm'),
        updated_at: moment(data.date).format('YYYY-MM-DD HH:mm'),
        hl_left: this.checkStringValueNotUndefinedAndReturn(data.measurements.filter(elem => elem.typeId === HEAR_LOSS_LEFT_TYPE_ID)[0], ''),
        hl_right: this.checkStringValueNotUndefinedAndReturn(data.measurements.filter(elem => elem.typeId === HEAR_LOSS_RIGHT_TYPE_ID)[0], ''),
        hl: this.parseBoolean(this.checkStringValueNotUndefinedAndReturn(data.measurements.filter(elem => elem.typeId === HEAR_LOSS_RESULT_TYPE_ID)[0], '')),
        hl_result: parseInt(this.checkStringValueNotUndefinedAndReturn(data.measurements.filter(elem => elem.typeId === HEAR_LOSS_RESULT_TYPE_ID)[0], '')),
        result: resultStr,
      }
      /*data.forEach(elem => {
        let results = {
          left: {},
          right: {}
        }
        elem.measurements.forEach(elem => {
          if (frequenciesToTypeIdMapping[elem.typeId]) {
            const side = frequenciesToTypeIdMapping[elem.typeId].side
            const freq = frequenciesToTypeIdMapping[elem.typeId].freq
            if (side && freq) {
              results[side][freq] = elem.value
            }
          }
        })

        let resultStr = `F\t1000\t2000\t4000\t6000\nR\t${results.right['1000']}\t${results.right['2000']}\t${results.right['4000']}\t${results.right['6000']}\nL\t${results.left['1000']}\t${results.left['2000']}\t${results.left['4000']}\t${results.left['6000']}`
        this.audiologyData.push({
          created_at: moment(elem.date).format('YYYY-MM-DD HH:mm'),
          updated_at: moment(elem.date).format('YYYY-MM-DD HH:mm'),
          hl_left: this.checkStringValueNotUndefinedAndReturn(elem.measurements.filter(elem => elem.typeId === HEAR_LOSS_LEFT_TYPE_ID)[0], ''),
          hl_right: this.checkStringValueNotUndefinedAndReturn(elem.measurements.filter(elem => elem.typeId === HEAR_LOSS_RIGHT_TYPE_ID)[0], ''),
          hl: this.parseBoolean(this.checkStringValueNotUndefinedAndReturn(elem.measurements.filter(elem => elem.typeId === HEAR_LOSS_RESULT_TYPE_ID)[0], '')),
          hl_raw: parseInt(this.checkStringValueNotUndefinedAndReturn(elem.measurements.filter(elem => elem.typeId === HEAR_LOSS_RESULT_TYPE_ID)[0], '')),
          result_graph_str: resultStr,
          automatic: elem.automatic,
        })
      })*/
    },
    parseBoolean: function (val) {
      const value = typeof val === "string" ? parseInt(val) : val
      return value === 1 ? this.$t('clinical.labels.yes') : this.$t('clinical.labels.no')
    },
    checkStringValueNotUndefinedAndReturn: function (val, unit = '', round = false, isBoolean = false) {
      if (val && val.stringValue) {
        if (round) {
          let roundedVal = this.roundStringValueToNearestTenth(val.stringValue)
          return isBoolean ? this.parseBoolean(`${roundedVal} ${unit}`) : `${roundedVal} ${unit}`
        } else {
          return isBoolean ? this.parseBoolean(`${val.stringValue} ${unit}`) : `${val.stringValue} ${unit}`
        }
      } else return "--"
    },
  },
  computed: {
    measurementTypesInfo: function () {
      return this.$store.state.checkup.measurementTypesInfo
    }
  }
};
</script>

<style scoped lang="scss">
.grid-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 5px;
}
</style>
